import { render, staticRenderFns } from "./aws-s3-download.vue?vue&type=template&id=fa745142&scoped=true"
import script from "./aws-s3-download.vue?vue&type=script&lang=js"
export * from "./aws-s3-download.vue?vue&type=script&lang=js"
import style0 from "./aws-s3-download.vue?vue&type=style&index=0&id=fa745142&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa745142",
  null
  
)

export default component.exports